import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef, Optional, Self, Injector, forwardRef } from '@angular/core';
import { ControlValueAccessor, NgControl, FormControlDirective, UntypedFormControl, NG_VALUE_ACCESSOR, FormControlName, FormGroupDirective } from '@angular/forms';
import { Document } from 'src/app/models/document.model';

@Component({
    selector: 'app-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FileUploaderComponent), multi: true }
    ]
})
export class FileUploaderComponent implements OnInit, ControlValueAccessor {

    @Output() documentChange = new EventEmitter();

    public documentValue: Document | undefined;
    @Input()
    get document() {
        return this.documentValue;
    }
    set document(val: Document | undefined) {
        this.documentValue = val;
        this.documentChange.emit(this.documentValue);
        this.onChange(val);
    }

    @Input()
    disabled: boolean;

    @Input()
    label: string;

    @Input()
    requiredErrorMessage?: string;

    @Input()
    hint?: string;

    control?: UntypedFormControl;

    @ViewChild('fileInput')
    fileInputRef: ElementRef<HTMLInputElement>;

    onChange = (_: Document | undefined) => {};
    onTouched = () => {};

    constructor(private injector: Injector) {}

    ngOnInit() {
        const ngControl = this.injector.get(NgControl);
        if (ngControl instanceof FormControlName) {
            this.control = this.injector.get(FormGroupDirective).getControl(ngControl);
        } else {
            this.control = (ngControl as FormControlDirective).form;
        }
    }

    writeValue(obj: any): void {
        if (obj?.nombreArchivo) {
            this.document = obj;
        } else {
            this.document = undefined;
        }
    }

    registerOnChange(fn: (p: Document | undefined) => void) {
        this.onChange = fn;
        this.onChange(this.documentValue);
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    onFileUpload(event: Event) {
        const files = Array.from((event.target as HTMLInputElement).files);
        if (files.length) {
            this.document = {
                archivo: files[0],
                nombreArchivo: files[0].name
            };
            this.onTouched();
        }
    }

    deleteFile() {
        this.document = undefined;
        this.fileInputRef.nativeElement.value = null;
        this.onTouched();
    }
}
